module.exports = __webpack_public_path__ + "static/media/prize-icon.d502ffb8.png";